import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const TransparencyHeader = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const headerData =
    labels.menuPages?.buyCar?.transparencySection?.header || {};

  return (
    <div className="text-center mb-8 md:mb-12 max-w-3xl mx-auto">
      <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 md:mb-4">
        {headerData.title || "100% Transparent Testning"}
      </h2>
      <p className="text-base md:text-lg text-gray-600 px-4">
        {headerData.description ||
          "Testet är transparent så allting visas i testet och det är det vi står för och säljer för."}
      </p>
    </div>
  );
};

export default TransparencyHeader;
